import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { UserContext } from '../userContext';
import { 
  FaSearch, FaFileAlt, FaCode, FaCalculator, FaDatabase, FaGlobe, 
  FaServer, FaBook, FaFlask, FaUsers, FaTools, FaChartBar, FaBrain, 
  FaRobot, FaPencilAlt, FaAtom, FaLanguage, FaHeart, FaIndustry,
  FaClipboardList, FaMicroscope, FaUserGraduate, FaRegHeart 
} from 'react-icons/fa';
import './CategoriaDetalhada.css';
import { normalizeText } from '../utils/text';

function CategoriaDetalhada() {
  const { nome } = useParams();
  const [categoria, setCategoria] = useState(null);
  const [busca, setBusca] = useState('');
  const navigate = useNavigate();
  const { user, userFavorites, toggleFavorite } = useContext(UserContext);

  useEffect(() => {
    const fetchCategoria = async () => {
      const ref = collection(db, 'categories');
      const snapshot = await getDocs(ref);
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      const cat = data.find(c => c.name === nome);
      if (cat) setCategoria(cat);
    };
    fetchCategoria();
  }, [nome]);

  const filtrarSubcategorias = (subs, termo) => {
    if (!termo) return subs;
    const lower = normalizeText(termo);
    return subs.filter(sub => normalizeText(sub.name).includes(lower));
  };

  // COR ÚNICA AZUL PARA TODOS OS CARDS - como na Computação
  const getCategoriaColor = () => {
    // Sempre retorna azul, independente da categoria
    return { color: '#3498db', bgColor: 'rgba(52, 152, 219, 0.1)' };
  };

  // SISTEMA DE ÍCONES AUTOMÁTICOS BASEADO EM PALAVRAS-CHAVE - igual ao modal
  const getIconForSubcategory = (subcategoryName) => {
    const name = subcategoryName.toLowerCase();
    
    // Programação/Algoritmos
    if (name.includes('algoritmo') || name.includes('programação') || name.includes('código')) 
      return FaCode;
    
    // Matemática/Cálculo
    if (name.includes('cálculo') || name.includes('matemática') || name.includes('estatística'))
      return FaCalculator;
    
    // Banco de Dados
    if (name.includes('banco') || name.includes('dados') || name.includes('sql'))
      return FaDatabase;
    
    // Web/Interface
    if (name.includes('web') || name.includes('interface') || name.includes('front'))
      return FaGlobe;
    
    // Sistemas/Infraestrutura
    if (name.includes('sistema') || name.includes('infraestrutura') || name.includes('servidor'))
      return FaServer;
    
    // Ciências/Química/Física
    if (name.includes('química') || name.includes('física') || name.includes('ciência'))
      return FaFlask;
    
    // Administração/Gestão
    if (name.includes('administração') || name.includes('gestão') || name.includes('negócio'))
      return FaUsers;
    
    // Ferramentas/Desenvolvimento
    if (name.includes('desenvolvimento') || name.includes('ferramenta') || name.includes('software'))
      return FaTools;
    
    // Estatística/Gráficos
    if (name.includes('estatística') || name.includes('probabilidade') || name.includes('gráfico'))
      return FaChartBar;
    
    // IA/Machine Learning
    if (name.includes('inteligência') || name.includes('machine') || name.includes('learning'))
      return FaBrain;
    
    // Robótica/Automação
    if (name.includes('robótica') || name.includes('automação') || name.includes('robot'))
      return FaRobot;
    
    // Provas/Avaliações
    if (name.includes('prova') || name.includes('avaliação') || name.includes('teste'))
      return FaPencilAlt;
    
    // Ciências da Natureza
    if (name.includes('natureza') || name.includes('biologia') || name.includes('átomo'))
      return FaAtom;
    
    // Linguagens/Comunicação
    if (name.includes('linguagem') || name.includes('comunicação') || name.includes('português'))
      return FaLanguage;
    
    // Saúde/Medicina
    if (name.includes('saúde') || name.includes('medicina') || name.includes('anatomia'))
      return FaHeart;
    
    // Engenharia/Produção
    if (name.includes('engenharia') || name.includes('produção') || name.includes('industrial'))
      return FaIndustry;
    
    // Planejamento/Organização
    if (name.includes('planejamento') || name.includes('organização') || name.includes('estratégia'))
      return FaClipboardList;
    
    // Pesquisa/Laboratório
    if (name.includes('pesquisa') || name.includes('laboratório') || name.includes('experimento'))
      return FaMicroscope;
    
    // Educação/Pedagogia
    if (name.includes('educação') || name.includes('pedagogia') || name.includes('ensino'))
      return FaUserGraduate;
    
    // Padrão
    return FaBook;
  };

  const handleFavoriteClick = (subcategoria, e) => {
    e.stopPropagation();
    if (!user) {
      navigate('/login');
      return;
    }
    toggleFavorite(subcategoria);
  };

  return (
    <div className="categoria-premium-container">
      {/* Barra colorida no topo */}
      <div className="categoria-color-bar"></div>
      
      <div className="categoria-header-premium">
        <h1 className="categoria-titulo-premium">{nome}</h1>
        
        <div className="categoria-search-premium">
          <FaSearch className="categoria-search-icon" />
          <input
            type="text"
            className="categoria-search-input"
            placeholder="Buscar subcategorias..."
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
          />
        </div>
      </div>

      <div className="categoria-content-premium">
        {categoria ? (
          filtrarSubcategorias(categoria.subcategories, busca).length > 0 ? (
            <div className="categoria-cards-grid-premium">
              {filtrarSubcategorias(categoria.subcategories, busca).map((sub, idx) => {
                const { color, bgColor } = getCategoriaColor(); // Sempre azul
                const IconComponent = getIconForSubcategory(sub.name); // Ícone automático
                const isFavorite = userFavorites && userFavorites.includes(sub.name);
                
                return (
                  <div
                    key={idx}
                    className="categoria-card-premium"
                    style={{
                      '--card-bg': bgColor,
                      '--card-color': color
                    }}
                  >
                    {/* Botão de favorita */}
                    <button
                      className={`categoria-favorite-button ${isFavorite ? 'favorited' : ''}`}
                      onClick={(e) => handleFavoriteClick(sub.name, e)}
                      title={isFavorite ? 'Remover dos favoritos' : 'Adicionar aos favoritos'}
                    >
                      {isFavorite ? <FaHeart /> : <FaRegHeart />}
                    </button>
                    
                    {/* Conteúdo do card */}
                    <div
                      className="categoria-card-content"
                      onClick={() => navigate(`/materiais/${encodeURIComponent(sub.name)}`)}
                    >
                      <IconComponent className="categoria-card-icon" />
                      <span className="categoria-card-title">{sub.name}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="categoria-no-results">
              <div className="categoria-no-results-icon">
                <FaSearch />
              </div>
              <p>Nenhuma subcategoria encontrada</p>
              <small>Tente ajustar sua busca ou explore outras categorias</small>
            </div>
          )
        ) : (
          <div className="categoria-loading">
            <div className="categoria-loading-spinner"></div>
            <p>Carregando subcategorias...</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default CategoriaDetalhada;
